// Shared CSRF-state handling for the connector callbacks (GitHub install, Notion OAuth).
//
// The `state` we round-trip is JSON, and it comes back through the URL, so it is fully
// attacker-controlled by the time we read it. Parsing it with a bare JSON.parse throws on
// garbage and takes the callback effect down with it, so both callbacks read it through here.

/** The `rnd` field out of a round-tripped state param, or null if it is absent or malformed. */
export const safeParseRnd = (state: string): string | null => {
  try {
    const parsed: unknown = JSON.parse(state)
    if (parsed && typeof parsed === 'object' && 'rnd' in parsed) {
      const rnd = (parsed as { rnd: unknown }).rnd
      return typeof rnd === 'string' ? rnd : null
    }
  } catch {
    // malformed state — treated as no state at all
  }
  return null
}
